import last from "lodash/last";
import isEmpty from "lodash/isEmpty";
import head from "lodash/head";
import get from "lodash/get";
import first from "lodash/first";
import isNull from 'lodash/isNull'
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  CUSTOM_VALUE_OPEN_DIGITAL_PRICES_DIALOG,
  getCustomValue,
  setCustomValue,
} from "../../v2_actions/custom_value";
import {
  Convert12hrTimeTo24hrTime,
  DEFAULT_TIME_END_12HR,
  DEFAULT_TIME_END_24HR,
  DEFAULT_TIME_START_12HR,
  DEFAULT_TIME_START_24HR,
} from "../../v2_actions/time";
import { Global, css } from "@emotion/react";
import {
  basePhotographList,
  photographList,
} from "../../v2_actions/customer_photograph";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useLayoutEffect, useRef } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BibNumber from "../../v2_components/BibNumber";
import CachedIcon from "@mui/icons-material/Cached";
import FaceIcon from "@mui/icons-material/Face";
import ThirtyFpsSelectIcon from "@mui/icons-material/ThirtyFpsSelect";
import Looks6Icon from "@mui/icons-material/Looks6";
import FacialRecognition from "../../v2_components/FacialRecognition";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import GalleryPhotographsLayout from "./GalleryPhotographsLayout";
import LaptopIcon from "@mui/icons-material/Laptop";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import RangeSlider from "../../v2_components/form/TimeRangeSlider";
import ReusableTabs from "../../v2_components/TabPanel";
import SideBar from "../../layout/sidebar";
import TopBar from "../../views/galleryphotographs/topbar";
import { galleryList } from "../../v2_actions/gallery";
import { albumListForEventTab } from "../../v2_actions/customer_album";
import { makeLogger } from "../../utils/o11y/logger";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import style from "../../views/galleryphotographs/styles";
import { trolleyList } from "../../v2_actions/trolley";
import { useIsMobile } from "../../actions/ui";
import DigitalPricesDialog from "../../views/galleryphotographs/DigitalPricesDialog";

const logger = makeLogger({
  enabled: true,
  label: "GalleryPhotographsParent2",
  color: "blue",
});

const useStyles = makeStyles(style);

const global_styles = css`
  div.MuiAccordion-root {
    font-size: 12px;
    background: #f4f4f4;
  }
  div.MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: inherit;
  }
  div.MuiAccordion-root {
    box-shadow: none;
  }
  div.MuiAccordionSummary-root {
    padding-left: 0px;
    background: #f4f4f4;
  }
  div.MuiAccordionSummary-content {
    left: 35px;
    position: absolute;
  }
  div.MuiAccordionSummary-expandIconWrapper {
    left: 0px;
    position: absolute;
  }
  div.MuiAccordionSummary-expandIconWrapper svg {
    width: 25px;
    height: 24px;
  }
`;

const GalleryPhotographsParent2 = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { galleryId } = useParams();
  const [ searchParams ] = useSearchParams();
  const customerFaceTokenParam = searchParams.get("customerFaceToken");
  const albumIdParam = searchParams.get("albumId");
  const bibNumberParam = searchParams.get("bibNumber");
  const album = useSelector(() => albumListForEventTab.getObject(albumIdParam))
  const [tabValue, setTabValue] = useState(0);
  const [width] = useState(window.innerWidth);
  const [bibNumber, setBibNumber] = useState();
  const [showMethod, setShowMethod] = useState(false);
  const [isFacialRecognitionFilterActive, setIsFacialRecognitionFilterActive] =
    useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [submittedBibNumber, setSubmittedBibNumber] = useState();
  const [accordianExpanded, setAccordianExpanded] = useState(false);
  const galleries = useSelector(() => galleryList.getVisibleObjects());
  const photographs = useSelector(() => photographList.getVisibleObjects());
  const gallery = head(galleries);
  const customerFaceToken = get(
    basePhotographList.getFilter(),
    "customer_face_token",
  );

  const openDigitalPricesDialog = useSelector(
    (state) =>
      getCustomValue({
        state,
        name: CUSTOM_VALUE_OPEN_DIGITAL_PRICES_DIALOG,
      }) || false,
  );

  const [showClearFiltersButton, setShowClearFiltersButton] = useState(false);
  const [clearFiltersWasClicked, setClearFiltersWasClicked] = useState(false);
  const [bibNumberFilterHasInput, setBibNumberFilterHasInput] = useState(false);
  const [expandActiveMobileTabFilter, setExpandActiveMobileTabFilter] =
    useState(true);
  const [
    mayPerformBibNumberIndexingOfGalleryPhotographs,
    setMayPerformBibNumberIndexingOfGalleryPhotographs,
  ] = useState(false);
  const [
    mayPerformFacialRecognitionIndexingOfGalleryPhotographs,
    setMayPerformFacialRecognitionIndexingOfGalleryPhotographs,
  ] = useState(false);
  const [timeOfActivity, setTimeOfActivity] = useState({
    start: DEFAULT_TIME_START_12HR,
    end: DEFAULT_TIME_END_12HR,
  });

  const [timeOfActivity24HourFormat, setTimeOfActivity24HourFormat] = useState({
    start: DEFAULT_TIME_START_24HR,
    end: DEFAULT_TIME_END_24HR,
  });

  const minTimeOfActivity = get(gallery, "first_photograph_taken_at");
  const maxTimeOfActivity = get(gallery, "last_photograph_taken_at");
  const galleryPhotographFiltersArePristine =
    !customerFaceTokenParam &&
    !bibNumberParam &&
    !customerFaceToken &&
    !bibNumber &&
    timeOfActivity24HourFormat.start === DEFAULT_TIME_START_24HR &&
    timeOfActivity24HourFormat.end === DEFAULT_TIME_END_24HR;

  useEffect(() => {
    if (galleryId) {
      dispatch(
        galleryList.updateListFilter({
          db_id: galleryId,
        }),
      );
      dispatch(
        galleryList.fetchListIfNeeded({
          callSource: "GalleryPhotographsParent2",
        }),
      );
      submitFilters("FX:galleryId");
    }
  }, [galleryId]);

  useEffect(() => {
    logger.log("FX customerFaceToken", {
      galleryId,
      customerFaceToken,
      timeOfActivity,
      photographsEmpty: isEmpty(photographs),
      galleryPhotographFiltersArePristine,
    });
    if (customerFaceToken) {
      submitFilters("FX:customerFaceToken");
    }
  }, [customerFaceToken]);

  useEffect(() => {
    if (albumIdParam) {
      dispatch(albumListForEventTab.ensureObjectLoaded(albumIdParam))
    }
  }, [])

  useEffect(() => {
    logger.log("FX customerFaceTokenParam", {
      galleryId,
      customerFaceTokenParam,
      albumIdParam,
      timeOfActivity,
      photographsEmpty: isEmpty(photographs),
      galleryPhotographFiltersArePristine,
    });
    if (album) {
      submitFilters("FX customerFaceTokenParam");
    }
  }, [album.id])

  useEffect(() => {
    dispatch(trolleyList.invalidateList());
    dispatch(trolleyList.ensureTrolleyLoaded());
    return () => {
      setMayPerformFacialRecognitionIndexingOfGalleryPhotographs(false);
      clearFilters();
    };
  }, []);

  useEffect(() => {
    const bibNumberIsPristine = !submittedBibNumber;
    const timeOfActivityIsPristine =
      timeOfActivity24HourFormat.start === DEFAULT_TIME_START_24HR &&
      timeOfActivity24HourFormat.end === DEFAULT_TIME_END_24HR;
    const facialRecognitionIsPristine = !customerFaceToken;
    if (
      bibNumberIsPristine &&
      timeOfActivityIsPristine &&
      facialRecognitionIsPristine &&
      !isFacialRecognitionFilterActive
    ) {
      setShowClearFiltersButton(false);
    } else {
      setShowClearFiltersButton(true);
    }
  }, [
    timeOfActivity24HourFormat,
    submittedBibNumber,
    isFacialRecognitionFilterActive,
    customerFaceToken,
  ]);

  useEffect(() => {
    if (isFacialRecognitionFilterActive || customerFaceTokenParam) {
      setTimeOfActivity({
        start: DEFAULT_TIME_START_12HR,
        end: DEFAULT_TIME_END_12HR,
      });
    }
  }, [isFacialRecognitionFilterActive, customerFaceToken]);

  logger.log("render()", customerFaceToken);

  const submitFilters = async (source, updatedTimeOfActivity24HourFormat=null) => {
    logger.log("submitFilters", { source, customerFaceToken });
    logger.log("submitFilters", { source, customerFaceTokenParam });
    if (isConfidential && !customerFaceToken && !customerFaceTokenParam) {
      await dispatch(photographList.invalidateList());
      await dispatch(photographList.clearListFilter());
      return;
    }
    await dispatch(photographList.invalidateList());
    await dispatch(photographList.clearListFilter());
    let time_end = get(timeOfActivity24HourFormat, "end", "23:59")
    let time_start = get(timeOfActivity24HourFormat, "start", "0:00")
    if (!isNull(updatedTimeOfActivity24HourFormat)) {
      time_end = get(updatedTimeOfActivity24HourFormat, "end", "23:59")
      time_start = get(updatedTimeOfActivity24HourFormat, "start", "0:00")
    }
    let filter = {};
    if (customerFaceToken || bibNumber) {
      filter = {
        time_end: time_end,
        time_start: time_start,
        bib_number: bibNumber,
        probable_customer_face_token: customerFaceToken,
        gallery_db_id: get(gallery, "gallery_event")
                     ? null
                     : get(gallery, "db_id"),
        gallery_event_id: get(gallery, "gallery_event")
          ? get(gallery, "gallery_event")
          : null,
        shot_at_before: moment.utc(get(gallery, "shot_at_datetime"))
          .add(2, "days")
          .format(),
        shot_at_after: moment.utc(get(gallery, "shot_at_datetime"))
          .subtract(2, "days")
          .format(),
      };
    } else if (customerFaceTokenParam && albumIdParam && album) {
      filter = {
        time_end: time_end,
        time_start: time_start,
        probable_customer_face_token: customerFaceTokenParam,
        album_id: albumIdParam,
      };
    } else if (bibNumberParam && albumIdParam && album) {
      filter = {
        time_end: time_end,
        time_start: time_start,
        bib_number: bibNumberParam,
        album_id: albumIdParam,
      };
    } else {
      filter = {
        gallery_db_id: galleryId,
        time_end: time_end,
        time_start: time_start,
        probable_customer_face_token: undefined,
      };
    }
    submitFiltersSend(filter);
  };
  const submitFiltersSend = async (filter) => {
    logger.log("submitFiltersSend", filter);
    await dispatch(photographList.updateListFilter(filter));
    await dispatch(
      photographList.fetchListIfNeeded({
        callSource: "GalleryPhotographsParent2",
      }),
    );
  };

  const timeChangeHandler = (time) => setTimeOfActivity(time);

  const onChangeBibNumber = (event) => setBibNumber(event.target.value);

  const onSubmitBibNumber = () => {
    setBibNumberFilterHasInput(true);
    setSubmittedBibNumber(bibNumber);
    setExpandActiveMobileTabFilter(false);

    submitFilters("onSubmitBibNumber");
  };

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const triggerFacialRecognitionPhotographIndexing = () => {
    setMayPerformFacialRecognitionIndexingOfGalleryPhotographs(true);
  };

  const triggerBibGalleryPhotographIndexing = () => {
    setMayPerformBibNumberIndexingOfGalleryPhotographs(true);
  };

  const changeCompleteHandler = (time) => {
    !isMobile && setTimeOfActivity24HourFormat(Convert12hrTimeTo24hrTime(time));
  };

  const handleAccordianTabChange = (panel) => (event, isExpanded) => {
    setAccordianExpanded(isExpanded ? panel : false);
  };

  const onClickSetTime = () => {
    const formattedTimeOfActivity = Convert12hrTimeTo24hrTime(timeOfActivity)
    setTimeOfActivity24HourFormat(formattedTimeOfActivity);
    setExpandActiveMobileTabFilter(false);
    submitFilters("onClickSetTime", formattedTimeOfActivity);
  };

  const onCancelTimeOfActivityFilter = () => {
    setTimeOfActivity({
      start: DEFAULT_TIME_START_12HR,
      end: DEFAULT_TIME_END_12HR,
    });
    setTimeOfActivity24HourFormat({
      start: DEFAULT_TIME_START_24HR,
      end: DEFAULT_TIME_END_24HR,
    });
    setExpandActiveMobileTabFilter(false);
  };

  const clearFilters = async () => {
    logger.log("clearFilters");
    setBibNumber("");
    setIsFacialRecognitionFilterActive(false);
    setSubmittedBibNumber("");
    setClearFiltersWasClicked(true);
    setTimeOfActivity({
      start: DEFAULT_TIME_START_12HR,
      end: DEFAULT_TIME_END_12HR,
    });
    setTimeOfActivity24HourFormat({
      start: DEFAULT_TIME_START_24HR,
      end: DEFAULT_TIME_END_24HR,
    });
    setExpandActiveMobileTabFilter(false);
    await dispatch(photographList.clearListFilter());
    await dispatch(basePhotographList.clearListFilter());
    await dispatch(photographList.invalidateList());
    if (!isConfidential) {
      await submitFiltersSend({
        gallery_db_id: galleryId,
        time_end: get(timeOfActivity24HourFormat, "end", "23:59"),
        time_start: get(timeOfActivity24HourFormat, "start", "0:00"),
        probable_customer_face_token: undefined,
      });
    }
  };
  const renderFacialRecognitionFilter = () => {
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <FacialRecognition
          gallery={gallery}
          setIsFacialRecognitionFilterActive={
            setIsFacialRecognitionFilterActive
          }
          clearFiltersWasClicked={clearFiltersWasClicked}
          setClearFiltersWasClicked={setClearFiltersWasClicked}
          expandActiveMobileTabFilter={expandActiveMobileTabFilter}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          mayPerformFacialRecognitionIndexingOfGalleryPhotographs={
            mayPerformFacialRecognitionIndexingOfGalleryPhotographs
          }
          setMayPerformFacialRecognitionIndexingOfGalleryPhotographs={
            setMayPerformFacialRecognitionIndexingOfGalleryPhotographs
          }
        />
      </Stack>
    );
  };

  const renderBibNumberFilter = () => {
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <BibNumber
          gallery={gallery}
          bibNumber={bibNumber}
          onSubmitBibNumber={onSubmitBibNumber}
          onChangeBibNumber={onChangeBibNumber}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          mayPerformBibNumberIndexingOfGalleryPhotographs={
            mayPerformBibNumberIndexingOfGalleryPhotographs
          }
        />
      </Stack>
    );
  };

  const renderTimeOfActivityFilter = () => {
    // logger.log("renderTimeOfActivityFilter", {
    //   timeOfActivity,
    //   minTimeOfActivity,
    //   maxTimeOfActivity,
    // });
    return (
      <Stack direction={{ xs: "column", sm: "row" }}>
        <RangeSlider
          value={timeOfActivity}
          minValue={minTimeOfActivity}
          maxValue={maxTimeOfActivity}
          onClickSetTime={onClickSetTime}
          handleChange={timeChangeHandler}
          isFacialRecognitionFilterActive={isFacialRecognitionFilterActive}
          changeCompleteHandler={changeCompleteHandler}
          onClickCancelRangeSlider={onCancelTimeOfActivityFilter}
        />
      </Stack>
    );
  };

  const renderDigitalPrices = () => {
    return <Typography>do renderDigitalPrices</Typography>;
  };

  const renderPrintingAndFramingPrices = () => {
    return <Typography>do renderPrintingAndFramingPrices</Typography>;
  };

  const bibIndexStatus = get(
    gallery,
    "indexed_for_bib_number_recognition",
    "not_indexed"
  );
  const isGalleryIndexedForBibRecognition = bibIndexStatus === "indexed" || bibIndexStatus === "partial";

  const isConfidential = get(gallery, "privacy_level") === "confidential"

  const canIndexForFacialRecognition = isConfidential || get(
    gallery,
    "can_index_for_facial_recognition",
    false
  );

  const sideMenuFilters = [
    ...(canIndexForFacialRecognition ? [{
      icon: <PersonSearchIcon />,
      for_facial_recognition: true,
      heading: "Facial Recognition",
      body: renderFacialRecognitionFilter(),
    }] : []),
    ...(isGalleryIndexedForBibRecognition ? [{
      icon: <Looks6Icon />,
      for_bib_recognition: true,
      heading: "Bib number",
      body: renderBibNumberFilter(),
    }] : []),
    ...(!albumIdParam ? [{
      icon: <AccessTimeIcon />,
      heading: "Time of Activity",
      body: renderTimeOfActivityFilter(),
    }] : []),
  ];

  const sideMenuPricing = [
    {
      icon: <LaptopIcon />,
      heading: "Prices & Discounts",
      body: renderDigitalPrices(),
    },
    {
      icon: <FilterFramesIcon />,
      heading: "Printing & Framing",
      body: renderPrintingAndFramingPrices(),
    },
  ];

  const openPricesDialog = () => {
    setExpandActiveMobileTabFilter(false);
    dispatch(
      setCustomValue({
        name: CUSTOM_VALUE_OPEN_DIGITAL_PRICES_DIALOG,
        value: true,
      }),
    );
  };

  const mobileTabPanelColumns = [
    ...(!albumIdParam ? [{
      icon: <AccessTimeIcon />,
      title: "Activity Time",
    }] : []),
    ...(canIndexForFacialRecognition ? [{
      icon: <FaceIcon />,
      title: "Facial Recognition",
    }] : []),
    ...(isGalleryIndexedForBibRecognition ? [{
      icon: <ThirtyFpsSelectIcon />,
      title: "Bib Number",
    }] : []),
    {
      icon: <AttachMoneyIcon />,
      title: "Prices & Discounts",
      onClick: openPricesDialog,
    },
  ];

  const renderMobileGalleryPhotographsParentView = () => {
    const mobileRows = [
      ...(!albumIdParam ? [renderTimeOfActivityFilter()] : []),
      ...(canIndexForFacialRecognition ? [renderFacialRecognitionFilter()] : []),
      ...(isGalleryIndexedForBibRecognition ? [renderBibNumberFilter()] : []),
      null,
    ];
    return (
      <Box>
        <ReusableTabs
          scrollButtons
          variant="scrollable"
          columns={mobileTabPanelColumns}
          expandActiveMobileTabFilter={expandActiveMobileTabFilter}
          setExpandActiveMobileTabFilter={setExpandActiveMobileTabFilter}
          rows={mobileRows}
        />
      </Box>
    );
  };

  return (
    <>
      <Global styles={global_styles} />
      <SideBar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
      <div
        onContextMenu={(e) => {
          e.preventDefault();
        }}
        className={
          !showSideBar
            ? `${classes.nonMennuWrapper} ${classes.nonMennuWrapperForGalleryPhotographs}`
            : classes.menuWrapper
        }
      >
        <div className={classes.contentContainer + " gallery-scroll-container"}>
          <div className={classes.content}>
            {isMobile && (
              <>
                <TopBar
                  gallery={gallery}
                  showSideBar={showSideBar}
                  setShowSideBar={setShowSideBar}
                  galleryId={galleryId}
                  showMethod={showMethod}
                  setShowMethod={setShowMethod}
                  width={width}
                />
                {renderMobileGalleryPhotographsParentView()}
              </>
            )}
            <Box className={classes.galleryPhotographsLayout} sx={{ marginTop: isMobile ? "20px" : "0px" }}>
              <GalleryPhotographsLayout
                gallery={gallery}
                enableTrolleyIcon={true}
                isConfidential={isConfidential}
                galleryPhotographFiltersArePristine={
                  galleryPhotographFiltersArePristine
                }
                mobiClearFiltersButton={
                  <Button
                    px={5}
                    pb={1}
                    onClick={clearFilters}
                    startIcon={<CachedIcon />}
                    className={classes.mobiClearFiltersButton}
                  >
                    <p style={{ fontWeight: "bold" }}>Clear Filters</p>
                  </Button>
                }
                customerFaceToken={ customerFaceToken }
              />
            </Box>
            {isMobile && openDigitalPricesDialog && (
              <DigitalPricesDialog
                gallery={gallery}
                openDigitalPricesDialog={openDigitalPricesDialog}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GalleryPhotographsParent2;
